import React, { useEffect, useContext } from 'react'

import { SOCIAL_LOGIN_API } from '../../utils/apiUrls'
import { useNavigate } from 'react-router'
import { AppContext } from '../../context/app'
import useAxios from 'axios-hooks'
import Logo from '../../assets/socialLogin/google-social-login.png'
import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth' // Add this line

const firebaseConfig = {
  apiKey: 'AIzaSyDl1qE53SMzL-Ur2wI85kyeTfd87brRvlY',
  authDomain: 'auth.lumicko.com',
  projectId: 'lumicko-ott',
  storageBucket: 'lumicko-ott.firebasestorage.app',
  messagingSenderId: '244466193708',
  appId: '1:244466193708:web:6475a8232a5e9ae6eb4889',
}

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp()

const GoogleAuth = ({ textColor = '#dcdcdc', borderColor = '#dddddd', isModal = false }) => {
  const navigate = useNavigate()
  const { setLoader, setUser, setOpenLoginModal } = useContext(AppContext)

  const [{ data: loginRes, loading: loginResLoading }, loginCall] = useAxios(
    {
      url: SOCIAL_LOGIN_API,
      method: 'post',
    },
    { manual: true },
  )
  useEffect(() => {
    if (loginRes && loginRes.success) {
      setUser(loginRes?.data)
      if (isModal) {
        setOpenLoginModal(false)
      } else {
        navigate(`/`)
      }
    }
  }, [loginRes])

  useEffect(() => {
    setLoader(loginResLoading)
  }, [loginResLoading])

  // Initialize Auth and Provider
  const auth = getAuth(app)
  const googleProvider = new GoogleAuthProvider()

  const signInWithGoogle = () => {
    signInWithPopup(auth, googleProvider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result)
        const token = credential.idToken

        loginCall({
          data: {
            provider: 'google',
            token: token,
          },
        })
      })
      .catch((error) => {
        console.error('Login Failed', error)
      })
  }

  return isModal ? (
    <div
      style={{ width: '105px', height: '30px', background: '#dddddd' }}
      className="rounded text-sm flex items-center justify-center cursor-pointer"
      onClick={signInWithGoogle}
    >
      <img src={Logo} alt="Google Logo" style={{ width: '18px', height: '18px' }} />
      <p style={{ color: '#393939', marginLeft: '8px' }} className="">
        Google
      </p>
    </div>
  ) : (
    <div
      style={{ border: `0.5px solid ${borderColor}`, height: '30px', color: textColor }}
      className="w-full rounded flex items-center justify-center overflow-hidden relative cursor-pointer"
      onClick={signInWithGoogle}
    >
      <div
        style={{ width: '38px' }}
        className="absolute left-0 h-full flex items-center justify-center bg-white"
      >
        <img src={Logo} alt="Google Logo" style={{ width: '18px', height: '18px' }} />
      </div>
      <p className="text-sm">Continue with Google</p>
    </div>
  )
}

export default GoogleAuth
